<template>
  <div class="cleed-grid" :class="{ 'litle-grid': grid.mode != 'quiz' }">
    <div class="cleed-grid-sizer"></div>
    <transition
      v-for="(item, idx) in arrItemsRender"
      :key="idx"
      name="cleed-grid-fade"
    >
      <product-card
        v-if="transition_idx != idx"
        :product="item"
        class="cleed-grid-item"
        :like-dislike="likeDislike"
        :brand="brand"
        :name="name"
        :price="price"
        @click.native="reload(item, idx)"
      ></product-card>
      <!--      <div-->
      <!--        class="cleed-grid-item"-->
      <!--        v-if="arrItemsRender.length"-->
      <!--        @click="reload(item)"-->
      <!--      >-->
      <!--        <img :src="item.picture_url" alt="clothes" />-->
      <!--&lt;!&ndash;        <p v-if="item.description">{{ item.description }}</p>&ndash;&gt;-->
      <!--      </div>-->
    </transition>
  </div>
</template>

<script>
import Masonry from "masonry-layout";
import imagesloaded from "imagesloaded";
import ProductCard from "./ProductCard";
import utils from '../utils'

export default {
  name: "Grid",
    components: {
      ProductCard
    },
  props: {
    grid: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      idxItems: 0,
      arrItemsRender: [],
      savedSelection: [],
      show: false,
      msnry: {},
      likeDislike: true,
      brand: true,
      name: true,
      price: true,
      transition_idx: null
    };
  },
  mounted() {
      // setting 4 images on component Mounted
      this.arrItemsRender = this.resetArrItemsRender();

      // check image rendering otherwise Masonry won't work correctly
      imagesloaded(".cleed-grid", { background: true }, () => {
          // init Masonry after all images have loaded
          this.msnry = new Masonry(".cleed-grid", {
              itemSelector: ".cleed-grid-item",
              columnWidth: ".cleed-grid-sizer",
              percentPosition: true,
          });
      });
  },
  methods: {
    resetArrItemsRender(click = false) {
      // Generating new set of ArrItemsRender
      if (click) {
        this.idxItems += 4;
      }
      let tmpArr = [];
      let tmp = this.idxItems;
      let idxItemsTmp = this.idxItems;

      if (this.grid.mode == "quiz") {
          this.likeDislike = false
          this.brand = false
          this.name = false
          this.price = false
        for (
          ;
          idxItemsTmp < this.grid.values.length && idxItemsTmp < tmp + 4;
          idxItemsTmp++
        ) {
          tmpArr.push(this.grid.values[idxItemsTmp]);
        }

        if (this.idxItems >= this.grid.values.length) {
          if (this.$store.state.user.style_profile)
            this.$eb.emit("StyleGridSelected", this.savedSelection);
          else
            this.$eb.emit("BoxGridSelected", this.savedSelection);

          for (this.idxItems = 0; this.idxItems < 4; this.idxItems++) {
              tmpArr.push(this.grid.values[this.idxItems])
          }
        }
        return tmpArr;
      } else if (this.grid.mode == "explore" || this.grid.mode == 'filter') {
          return this.grid.values
      }
    },
    reload(item, idx) {
        if (this.grid.mode == 'quiz') {
          // Reset arrItemsRender to active animation v-leave-active
          // from class v-leave  ------>  v-leave-to
          // this.arrItemsRender = [];
          this.transition_idx = idx
          this.savedSelection.push(item);

          setTimeout(() => {
            // Set arrItemsRender to active animation v-entrer-active
            // from class v-entrer  ------>  v-entrer-to
            this.transition_idx = null
            this.arrItemsRender = this.resetArrItemsRender(true);
          }, 500);
        } else if (this.grid.mode == "explore" || this.grid.mode == 'filter') {
          utils.openInTab(item.url)
        }
    },
  }
};
</script>
